/* This is the Health Problem for Climate Change components N.1 + GPS coordinate */

<template>
  <v-container>
    <!-- Implement the GPS Coordinate UTMX, UYMY here -->
    <div>
      <v-card class="px-2 ma-0" outlined>
        <v-row>
          <v-col align="right"
            ><p class="font-weight-bold">លេខកូអរដោនេ GPS:</p></v-col
          >
          <v-col class="px-1 mx-1">
            <v-text-field
              v-model="gps.x"
              dense
              hide-details="auto"
              type="number"
              label="UTM-X"
            ></v-text-field>
          </v-col>
          <v-col class="px-1 mx-1">
            <v-text-field
              v-model="gps.y"
              dense
              hide-details="auto"
              type="number"
              label="UTM-Y"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card>
    </div>

    <div>
      <br />
      <strong><span v-html="title + ' ' + cur_acc"></span></strong>
    </div>
    <div>
      <table border="1px;" cellspacing="0px;" width="800px;">
        <tbody>
          <tr>
            <td style="width: 200px; height: 25px; text-align: center">
              បញ្ហាសុខភាព
            </td>
            <td style="width: 100px; height: 25px; text-align: center">
              ចំនួនសិស្សសរុប (ទាំងពីរភេទ)
            </td>
            <td style="width: 500px; height: 25px; text-align: center">
              ព្រឹត្តិការណ៍គ្រោះមហន្តរាយ(ឧ. ទឹកជំនន់ / ព្យុះឬខ្យល់កន្រ្តាក់ /
              អាកាសធាតុក្តៅខ្លាំង / ទឹកសមុទ្រហៀរចូលទឹកសាប ។ល។)
            </td>
          </tr>
          <tr
            v-for="(value, row) in heapro.length"
            :key="row"
            style="height: 25px; text-align: left"
          >
            <td style="width: 200px; height: 25px">{{ heapro[row] }}</td>
            <td style="width: 100px; height: 25px">
              <numberinput
                v-model="data[row].dt.d"
                style="width: 100px; text-align: center"
              />
            </td>
            <td style="width: 500px; height: 25px">
              <input
                type="text"
                v-model="data[row].dt.e"
                style="width: 500px; text-align: center"
              />
              <!--
            <v-text-field
              class="pa-0 ma-1"
              single-line
              solo
              hide-details="auto"
              outlined
              v-model="data[row].dt.e"
            ></v-text-field>
            --></td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { heapro } from "@/utils/ascf/climateVariables.js";

export default {
  props: ["data", "gps", "title", "cur_acc"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      heapro: heapro,
    };
  },
  /*
  computed: {
  */
  /* get the label for table */
  /*
    labelRender: function () {
      if (this.type_code === 1) {
        return preLevel;
      } else if (this.type_code === 2) {
        return priLevel;
      } else {
        return secLevel;
      }
    },
    */
  /* totalRow are the summing of each column total and female */
  /*
    totalRow: function () {
      let result;
      let d = this.data;
      let ldata = this.data.length;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (ind < ldata) {
            // do summing 0 to last - 1 only (last is sum array)
            r[i] = (r[i] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
  },
  filters: {
    blank: function (value) {
      if (value == 0) return "";
      return value;
    },
  },
  */
};
</script>

<style scoped>
.number {
  width: 50px;
  text-align: center;
}
.td-white {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: white;
}
.td-light {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
.td-white-long {
  width: 250px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
  background-color: white;
}
.td-light-long {
  width: 250px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
  background-color: lightgray;
}
</style>